module.exports = __webpack_public_path__ + "static/img/design-4.66c5f272.png";